import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { IGoal } from "@gtmhub/goals/models";
import { Metric } from "@webapp/okrs/metrics/models/metric.models";
import { IPlanningSessionConflict, Session } from "@webapp/sessions/models/sessions.model";

@Component({
  selector: "session-conflict",
  templateUrl: "./session-conflict.component.html",
  styleUrls: ["./session-conflict.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionConflictComponent {
  @Input()
  public conflict: IPlanningSessionConflict;

  @Input()
  public sessionId: string;

  public conflictTitleKeys = Object.freeze<Record<IPlanningSessionConflict["type"], string>>({
    dueDate: "conflicts_with_hard_deadline",
    softDueDate: "conflicts_with_soft_deadline",
    crossSessionLink: "conflicts_with_linked_objective",
  });

  public conflictDescriptionKeys = Object.freeze<Record<IPlanningSessionConflict["type"], string>>({
    dueDate: "conflicts_hard_deadline_outside_session",
    softDueDate: "conflicts_soft_deadline_outside_session",
    crossSessionLink: "conflicts_linked_across_session",
  });

  public trackById(index: number, item: IGoal | Metric | Session): unknown {
    return item.id;
  }
}
